module.exports = __webpack_public_path__ + "img/5_uk.a02b4218.svg";